import { CHILDUPP_ID } from 'shared/childupp-properties';

/**
 * Returns a childupp-linked key for the given key.
 *
 * Returned key will be different if the page is loaded under the
 * same host but running different childupp ids. Said scenario is
 * mainly linked to development environments.
 *
 * @private
 * @param  {string} key - A key value to be used
 * @return {string}
 */
async function generatePrivateKey(key) {
    const childuppId = await CHILDUPP_ID;
    return `${childuppId}:${key}`;
}

/**
 * Saves the given value under the given key which persists it
 * between page loads. Said value can be  later retrieved by
 * passing the key to {@link #get}.
 *
 * @param  {string} key - A unique key to represent the value to be stored.
 * @param  {any} value - The value to be stored. Will be JSON serialized.
 * @return {Promise<any>}
 */
export async function save(key, value) {
    key = await generatePrivateKey(key);
    window.localStorage.setItem(key, JSON.stringify(value));
    return value;
}

/**
 * Retrieves the value for the given key. If value has never been
 * set via {@link #set} the value retruned will be `null`.
 *
 * @param  {string} key - The unique key representing the data to be retrieved
 * @return {Promise<any>}
 */
export async function get(key) {
    key = await generatePrivateKey(key);
    const value = window.localStorage.getItem(key);
    if (typeof value === 'undefined')
        return null;
    else
        return JSON.parse(value);
}

/**
 * Removes the value associated with the given key.
 * Future calls to {@link #get} with said key will return `null`.
 *
 * @param  {string} key - The unique key representing the data to be removed
 * @return {Promise<void>}
 */
export async function remove(key) {
    key = await generatePrivateKey(key);
    window.localStorage.removeItem(key);
}

export default {
    save,
    get,
    remove,
}



// WEBPACK FOOTER //
// ./src/shared/childupp-local-storage/index.js